import React, { useEffect, useState } from "react";
import Table from "../../components/Table";
import Layout from "../../layout/Layout";
import { getTypeActeurs } from "../../services/typeActeur";
import {
  deleteDocumentAuclient,
  updateDocumentAuclient,
  getDocumentAuclient,
  createDocumentAuclient
} from "../../services/documentAuclients";
import ReactPaginate from "react-paginate";
import Loading from "../../components/Loading";
import Alert from "../../components/Alert";
const DocumentAttributeClient = () => {

  const headTable = [
    { name: 'Type Acteur', width: "95%" },
    { name: "", with: "5%" }
  ]
  const [values, setValues] = useState({

    idtypact: "",
    libelle: ""
  })

  //pagination
  const [flash, setFlash] = useState({ message: null, color: "success" });
  const [TypeActeurs, setTypeActeurs] = useState([]);
  const [DocumentAttributeClients, setDocumentAttributeClients] = useState([]);
  const [current, setCurrent] = useState(null);
  const _getTypeActeurs = async () => {
    const { data } = await getTypeActeurs();
    setTypeActeurs(data);
  };

  // pagination code
  let PageSize = 10;
  const [isLoading, setIsLoading] = useState(false);
  const [currentTableData, setCurrentTableData] = useState([]);

  const [totalPage, setTotalPage] = useState(null);
  const page = (currentPage, datas) => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;

    return datas.slice(firstPageIndex, lastPageIndex);
  };

  const onPageChange = (e) => {
    const d = page(parseInt(e.selected + 1), DocumentAttributeClients);
    setCurrentTableData(d);
    // console.log(d);
  };
  const onSelectTypeActeurs = async (e) => {
    setIsLoading(true);
    setValues({ ...values, idtypact: e.target.value });
    getDocumentAuclient({ idtypact: e.target.value })
      .then((res) => {
        const { data, message } = res;
        // console.log(message);
        const d = page(1, data);
        setFlash({ ...flash, message: message, color: "success" });
        setDocumentAttributeClients(data);
        setCurrentTableData(d);
        const coutPage = parseInt(data.length / PageSize);
        // console.log(coutPage);
        setTotalPage(coutPage);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  //fin de paginatio;
  const handleChange = (e) => {
    setValues({ ...values, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    // console.log(isLoading);
    if (current) {
      const data = {
        idtypact: values.idtypact,
        libelle: values.libelle,
        id: current.ID,
      };
      if (data.idtypact.length === 0 || data.libelle.length === 0 || data.id.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      updateDocumentAuclient(data)
        .then((res) => {
          setFlash({ ...flash, message: res.data.message, color: "success" });
          setCurrent(null);
          getDocumentAuclient({ idtypact: values.idtypact })
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setDocumentAttributeClients(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
          setValues({ ...values, libelle: "" });
          setIsLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      if (values.idtypact.length === 0 || values.libelle.length === 0) {
        setFlash({ message: "Veuillez saisir les champs requis", color: "danger" });
        setIsLoading(false);
        return false;
      }
      createDocumentAuclient(values)
        .then((resultat) => {
          setFlash({ ...flash, message: resultat.data.message, color: "success" });
          getDocumentAuclient({ idtypact: values.idtypact })
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setDocumentAttributeClients(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
          setValues({ ...values, libelle: "" });
        })
        .catch((error) => {
          console.log(error);
          setFlash({
            ...flash,
            message: "Erreur de création",
            color: "danger",
          });

          getDocumentAuclient({ id: values.idtypact })
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setDocumentAttributeClients(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        });
    }
  };

  const onclick = (data) => {
    setCurrent(data);
    setValues({ ...values, idtypact: data.IDTACTEURFONCIER, libelle: data.LIBELLE });
  };

  const onDelete = async () => {
    if (window.confirm("Etre Vous sur de vouloir supprimer le document à fournir au client?")) {
      const data = { id: current.ID, nom: current.NOM };
      deleteDocumentAuclient(data)
        .then(({ data }) => {
          setIsLoading(true);
          setCurrent(null);
          setValues({ ...values, libelle: "" });
          setFlash({ ...flash, message: data.message });
          getDocumentAuclient({ idtypact: values.idtypact })
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setDocumentAttributeClients(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((error) => {
          // console.log(error.response);
          setIsLoading(true);
          setCurrent(null);
          setFlash({
            ...flash,
            color: "danger",
            message: error.response.data.message,
          });
          getDocumentAuclient({ id: values.idtypact })
            .then((res) => {
              const { data } = res;
              const d = page(1, data);
              setDocumentAttributeClients(data);
              setCurrentTableData(d);
              const coutPage = parseInt(data.length / PageSize);
              // console.log(coutPage);
              setTotalPage(coutPage);
              setIsLoading(false);
            })
            .catch((err) => {
              console.log(err);
            });
        });
    }
  };
  useEffect(() => {
    _getTypeActeurs();
  }, []);
  return (
    <Layout>
      <div className="row">
        <div className="col-xs-2" />
        <form onSubmit={handleSubmit}>
          <div className="form-horizontal col-xs-8 ui-sortable">
            <div className="widget-box widget-color-blue">
              {/* Entete du cadre */}
              <div className="widget-header ui-sortable-handle">
                <h5 className="widget-title">Saisie des documents à fournir au client</h5>
              </div>
              {/* Contenu du cadre */}
              <div className="widget-body">
                <div className="widget-main">
                  {flash?.message !== null && (
                    <Alert color={flash?.color} message={flash?.message} />
                  )}
                  <span
                    id="ContentPlaceHolder1_LBINFO"
                    style={{
                      display: "inline-block",
                      width: "100%",
                      textAlign: "center",
                    }}
                  />

                  {/* code form */}
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Type Acteur(*)
                    </label>
                    <select
                      name="idTypeActeurs"
                      className="form-control input-xxlarge "
                      onChange={onSelectTypeActeurs}
                    >
                      <option value="-1"></option>
                      {TypeActeurs?.map((item, key) => (
                        <option key={key} value={item.ID}>
                          {item.LIBELLE}
                        </option>
                      ))}
                    </select>
                  </label>
                  <label className="block clearfix">
                    <label htmlFor="text" className="col-lg-2">
                      Libellé (*)
                    </label>
                    <input
                      value={values.libelle}
                      onChange={handleChange}
                      name="libelle"
                      type="text"
                      className="form-control input-xxlarge"
                    />
                  </label>
                </div>
                {/* Pied du cadre */}
                <div className="widget-toolbox padding-8 clearfix">
                  <div className="pull-right">
                    <input
                      type="submit"
                      value="Enregistrer"
                      className="btn btn-success "
                      disabled={isLoading ? true : false}
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginRight: 2,
                        marginBottom: 2,
                      }}
                    />

                    {current && (
                      <input
                        type="button"
                        value="Supprimer"
                        className="btn btn-danger"
                        onClick={onDelete}
                        style={{
                          borderStyle: "None",
                          width: 100,
                          marginRight: 2,
                          marginBottom: 2,
                        }}
                      />
                    )}
                    <input
                      type="button"
                      value="Annuler"
                      className="btn btn-warning"
                      style={{
                        borderStyle: "None",
                        width: 100,
                        marginBottom: 2,
                      }}
                      onClick={() => {
                        setCurrent(null);
                        setValues({ ...values, libelle: "" });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>

      {isLoading ? (
        <Loading isLoading={isLoading} />
      ) : (
        <Table title={"Liste des documents à fournir au client"} headTable={headTable}>
          {currentTableData?.map((item, key) => (
            <tr key={key} style={{ color: "Black", backgroundColor: "White" }}>
              <td>{item.LIBELLE}</td>
              <td className="text-center" align="right">
                <img
                  onClick={() => onclick(item)}
                  style={{ width: 15, height: 10 }}
                  src={"/Catef_files/modifier.png"}
                />
              </td>
            </tr>
          ))}
          {/* pgination */}
          <tr
            className="pagination-od"
            align="center"
            style={{
              color: "Black",
              backgroundColor: "#EFF3F8",
              fontWeight: "normal",
              whiteSpace: "nowrap",
            }}
          >
            <td colSpan={5}>
              {totalPage != null && (
                <ReactPaginate
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  activeClassName={"active"}
                  breakLabel="..."
                  nextLabel="suivant >"
                  onPageChange={onPageChange}
                  pageRangeDisplayed={5}
                  pageCount={totalPage + 1}
                  previousLabel="< précédent"
                  renderOnZeroPageCount={null}
                />
              )}
            </td>
          </tr>
        </Table>
      )}
    </Layout>
  );
};

export default DocumentAttributeClient;
